export default {
  order: {
    sales: {
      ConfirmReceipt: 'Receipt',
      BaseInfo: 'Base Information',
      DeliverInfo: 'Deliver Information',
      DeliverStore: 'Deliver Store',
      OrderNo: 'Order No',
      DeliverOrderNo: 'Deliver Order No',
      ReceiptNo: 'Receipt No',
      Payee: 'Payee',
      OrderDate: 'Order Date',
      OrderTime: 'Order Time',
      DeliverDate: 'Deliver Date',
      Customer: 'Customer',
      Receiver: 'Receiver',
      Consignor: 'Consignor',
      Telephone: 'Telephone',
      OrderStatus: 'Order Status',
      PayStatus: 'Pay Status',
      PaymentMethod: 'Payment Method',
      BankCardPayment: 'Bank Card Payment',
      AdvancePayment: 'Advance Payment',
      Balance: 'Balance',
      Begin: 'Begin',
      End: 'End',
      DeliveryTime: 'Delivery Time',
      CollectedDate: 'Collected Date',
      PleaseChooseCollectedDate: 'Please Choose Collected Date',
      PaymentAccount: 'Payment Account',
      PleaseChoosePaymentAccount: 'Please Choose Payment Account',
      Serial: 'S/N',
      Address: 'Address',
      DeliverTime: 'Deliver Time',
      Quantity: 'Quantity',
      Amount: 'Amount',
      DiscountAmount: 'Discount Amount',
      OrderAmount: 'Order Amount',
      RefundAmount: 'Refund Amount',
      ReceivedAmount: 'Received Amount',
      UnpaidAmount: 'Unpaid Amount',
      CollectedAmount: 'Amount Collected',
      Discount: 'Discount',
      OrderPrice: 'Order Price',
      Source: 'Source',
      Deliver: 'Deliver',
      Gathering: 'Gathering',
      Unpaid: 'Unpaid',
      PartialPayment: 'Partial Payment',
      Paid: 'Paid',
      PendingApproval: 'To audit',
      Refused: 'Refused',
      Deleted: 'Deleted',
      AdminCancel: 'Admin Cancel',
      CustomCancel: 'Custom Cancel',
      Undelivered: 'Undelivered',
      ToAudit: 'To Audit',
      PartialDeliver: 'Partial Delivered',
      Delivered: 'Delivered',
      OrderQuantity: 'Order Quantity',
      DeliverableQuantity: 'Deliverable Quantity',
      DeliveryQuantity: 'Delivery Quantity',
      UnauditedQuantity: 'Unaudited Quantity',
      InventoryQuantity: 'Inventory Quantity',
      ThisQuantity: 'This Quantity',
      LogisticsCompany: 'Logistics Company',
      LogisticsNumber: 'Logistics Number',
      Recovered: 'Recovered',
      Completed: 'Completed',
      Total: 'Total',
      CancelOrderConfirm: 'Do you want to cancel the order?',
      DeleteOrderConfirm: 'Do you want to delete the order?',
      selectOrderTips: 'Select order',
      CheckOrderTips: 'Pass or refuse the order you have select',
      CheckOrderTitle: 'Order Verify',
      CheckPass: 'pass',
      CheckRefuse: 'refuse',
      NotPass: 'Not pass',
      DeliverCheckTips: 'The order were delivered, go to deliver list to verify',
      Gift: 'Gift',
      PleaseChooseTheReceivingAddress: 'Please Choose The Receiving Address.',
      PleaseChooseTheDeliveryWarehouse: 'Please Choose The Delivery Warehouse.',
      PleaseChooseTheShipper: 'Please Choose The Shipper.',
      PleaseChooseLogisticsCompany: 'Please Choose Logistics Company.',
      PleaseEnterLogisticsDocumentNumber: 'Please Enter Logistics Document Number.',
      PleaseChooseReceiver: 'Please Choose Receiver',
      PleaseChooseProvince: 'Please Choose Province',
      PleaseChooseCity: 'Please Choose City',
      PleaseChooseArea: 'Please Choose Area',
      SaveAndUse: 'Save And Use',
      UseNewAddress: 'Use New Address',
      SetAsDefault: 'Set As Default',
      Default: 'D',
      PleaseChooseAddress: 'Please Choose Address'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/ims/order.js